import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {/* Company Info */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Country State City</h3>
            <p className="text-sm text-gray-600 mb-3">
              Comprehensive geographical data export tool for developers and businesses.
            </p>
            <a
              href="https://demo.countrystatecity.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800"
            >
              <ExternalLink className="w-3 h-3" />
              Try Demo
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/dashboard/exports" className="text-gray-600 hover:text-gray-900">
                  Create Export
                </Link>
              </li>
              <li>
                <Link to="/dashboard/credits" className="text-gray-600 hover:text-gray-900">
                  Buy Credits
                </Link>
              </li>
              <li>
                <Link to="/dashboard/exports/history" className="text-gray-600 hover:text-gray-900">
                  Export History
                </Link>
              </li>
              <li>
                <Link to="/dashboard/user-guide" className="text-gray-600 hover:text-gray-900">
                  User Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/dashboard/support" className="text-gray-600 hover:text-gray-900">
                  Contact Support
                </Link>
              </li>
              <li>
                <Link to="/dashboard/faq" className="text-gray-600 hover:text-gray-900">
                  FAQ
                </Link>
              </li>
              <li>
                <a href="mailto:export@countrystatecity.in" className="text-gray-600 hover:text-gray-900">
                  Email Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/support/privacy-policy" className="text-gray-600 hover:text-gray-900">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/support/refund-policy" className="text-gray-600 hover:text-gray-900">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/support/terms-of-service" className="text-gray-600 hover:text-gray-900">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* CSC Platform Ecosystem */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-3">CSC Platform Ecosystem</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://demo.countrystatecity.in/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                  Demo Database
                </a>
              </li>
              <li>
                <a href="https://countrystatecity.in/product/api/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                  API Service
                </a>
              </li>

              <li>
                <a href="https://countrystatecity.in/product/update-tool/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                  Update Tool
                </a>
              </li>
              <li>
                <a href="https://countrystatecity.org/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                  Geographical Encyclopedia
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-6 pt-6 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Country State City. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-3 sm:mt-0">
            <Link to="/support/privacy-policy" className="text-xs text-gray-500 hover:text-gray-700">
              Privacy
            </Link>
            <Link to="/support/refund-policy" className="text-xs text-gray-500 hover:text-gray-700">
              Refunds
            </Link>
            <Link to="/support/terms-of-service" className="text-xs text-gray-500 hover:text-gray-700">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
